import styled, { css } from 'styled-components';
import BG from '../../../static/signUpBg.png';
import { Field, ErrorMessage } from 'formik';
import { Link } from 'react-scroll';

export const Container = styled.div`
  padding: 30px;
  background-image: linear-gradient(
    -146deg,
    rgba(243, 100, 33, 0.4) 0%,
    rgba(231, 229, 22, 0.4) 92%
  );

  ${({ small }) =>
    small &&
    css`
      height: calc(100vh - 60px);
    `};
`;

export const Card = styled.div`
  background: #fff;
  padding: 30px 20px 5px;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.13);
  text-align: center;
  width: calc(100vw - 60px);
  max-width: calc(800px - 60px);
  margin-right: 60px;

  ${({ background }) =>
    background &&
    css`
      background: #fff url(${BG}) no-repeat;
      background-size: contain;
      background-position-y: bottom;
    `};
`;

export const Title = styled.h2`
  font-weight: 300;
  font-size: 1.7em;
  line-height: 1.2;

  ${({ small }) =>
    small &&
    css`
      font-size: 1.1em;
    `};

  ${({ medium }) =>
    medium &&
    css`
      font-size: 1.3em;
    `};

  ${({ underline }) =>
    underline &&
    css`
      position: relative;
      margin-bottom: 12px;

      &:after {
        position: absolute;
        bottom: -10px;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        content: '';
        width: 20px;
        height: 3px;
        background-color: #e8e530;
      }
    `};
`;

export const BtnGroup = styled.div`
  margin: 25px 0;

  p {
    font-size: 0.9em;
    line-height: 1.2;
  }

  button {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  ${({ circles }) =>
    circles &&
    css`
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    `};
`;

export const ProgressContainer = styled.div`
  ${({ circles }) =>
    circles &&
    css`
      flex-wrap: wrap;
      justify-content: space-between;
    `} display: flex;
  transition: all 320ms ease-out;
  ${({ step, total }) =>
    css`
      width: calc(${total} * (100vw));
      max-width: calc(${total} * 800px);
      transform: translateX(calc(${step} * -100vw));
      @media (min-width: 800px) {
        transform: translateX(calc(${step} * -800px));
      }
    `};
`;

export const Option = styled.button`
  color: #f36520;
  border: 1px solid #f36520;
  background: #fff;
  width: 100%;
  border-radius: 2px;
  line-height: 2.3;
  font-size: 1em;
  font-weight: 600;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.07);
  cursor: pointer;
  outline: none;

  ${({ circles }) =>
    circles &&
    css`
      border-radius: 50%;
      max-width: 200px;
      max-height: 200px;
      width: calc(29vw);
      height: calc(29vw);
      margin: 10px;
      line-height: 1;
    `} ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed !important;
    `} &:active {
    background: #f36520;
    color: #fff;
  }

  ${({ skip }) =>
    skip &&
    css`
      color: #9d9fa2;
      border-color: transparent;
      margin-top: 10px;
      box-shadow: none;
      &:active {
        color: #000;
        background: transparent;
      }
    `};
`;
export const Partner = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
`;

export const Name = styled.div`
  font-size: 1.3em;
`;

export const Price = styled.div`
  font-weight: 300;
  font-size: 2em;
  color: #93b7c8;

  ${({ blur }) =>
    blur &&
    css`
      filter: blur(6px);
    `};
`;

export const Sub = styled.p`
  display: block;
  color: #93b7c8;
  margin-top: 10px;
`;

export const HomeAddress = styled.div`
  color: #000
  font-weight: 600;
  font-size: .9em;
  border: none;
  width: 100%;

  .geosuggest__item {
    font-size: 1em !important;
  }

  .geosuggest {
    width: 100%;
    margin-bottom: 10px;
    font-size: 1.2em;

    input {
      background: #f1f1f1;
      color: #000
      font-weight: 600;
      font-size: 1.4rem;
      border: none !important;
      padding: 15px 10px;
      box-shadow: none;
      &::placeholder {
        color: rgba(0, 0, 0, 0.9);
      }
    }
  }
  
  &:focus {
    border-color: #93b7c8;
  }
`;

export const StyledErrorField = styled(ErrorMessage)`
  display: block;
  background: #fff;
  color: #000;
  padding: 8px;
`;

export const StyledField = styled(Field)`
  background: #f1f1f1;
  color: #000
  font-weight: 300;
  font-size: 1em;
  border: none;
  padding: 15px 10px;
  width: 100%;
  border-radius: 2px;
  margin-bottom: 6px;
  &::placeholder {
    color: #000;
  }
`;

export const TextInput = styled.input`
  background: #f1f1f1;
  color: #000
  font-weight: 300;
  font-size: 1em;
  border: none;
  padding: 15px 10px;
  width: 100%;
  border-radius: 2px;
  margin-bottom: 6px;
  &::placeholder {
    color: #000;
  }
`;

export const Btn = styled.button`
  display: block;
  text-align: center;
  text-decoration: none;
  width: 100%;
  border: none;
  border-radius: 2px;
  background-color: #f36421;
  color: #fff;
  font-size: 0.9em;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 16px;
  line-height: 3.2;
`;

export const Estimate = styled.div`
  width: calc(100% / 3);
  padding: 15px;
  border-right: 1px solid #93b8c9;
  text-align: center;
  &:last-child {
    border-right: none;
  }

  .partner {
    margin-bottom: 6px;
    text-transform: uppercase;
  }

  .price {
    font-weight: 300;
    color: #f36421;
    font-size: 4.2vw;

    @media (min-width: 800px) {
      font-size: 1.3em;
    }
  }

  .signUp {
    color: #93b8c9;
    font-size: 0.9em;
    font-weight: 800;
  }
`;

export const Values = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #93b8c9;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.03);
  margin-top: 10px;
`;

export const ValueContainer = styled.div`
  display: flex;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.05);
  margin: 15px 0;
`;

export const SmallEstimate = styled.div`
  width: 100%;
  border: 1px solid #93b8c9;
  border-right: none;
  padding: 10px;

  .val {
    margin-top: 5px;
    font-size: 1.05em;

    ${({ blur }) => {
      blur &&
        css`
          filter: blur(5px);
          opacity: 0.5;
        `;
    }};
  }

  img {
    max-width: 70%;
  }

  @media (max-width: 700px) {
    img {
      max-width: 100% !important;
      width: 100%;
    }
  }

  &:first-child {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  &:last-child {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    border-right: 1px solid #93b8c9;
  }
`;

export const PartnersContainer = styled.div`
  padding-top: 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
`;

export const PartnerWrapper = styled.div`
  border: 1px solid #93b8c9;
  margin-bottom: 15px;
  width: calc(50% - 10px);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;

  img {
    padding: 10px;
    width: 80%;
    max-width: 156px;
  }
`;

export const PartnerBtn = styled.button`
  transition: all 130ms ease-out;
  border: 1px solid ${({ selected }) => (selected ? '#f36520' : '#ccc')};
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: ${({ selected }) => (selected ? '#FCFCFC' : '#fff')};
  box-shadow: 0 5px 10px
    ${({ selected }) =>
      selected ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.02)'};
  outline: none;
  cursor: pointer;

  img {
    width: 50%;
    padding-right: 10px;
  }

  p {
    display: block;
    width: 100%;
    font-size: 1.05rem;
    margin-bottom: 0;
    padding-right: 5px;
  }
`;

export const NextBtn = styled(Link)`
  text-decoration: none;
  width: 100%;
  line-height: 3.2;
  display: block;
  padding: 5px 0;
  color: #fff;
  border: 1px solid #f36520;
  width: 100%;
  border-radius: 2px;
  line-height: 2.3;
  font-size: 1em;
  font-weight: 600;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.07);
  cursor: pointer;
  outline: none;
  background: #f36520;
  margin-top: 15px;

  &:active {
    background: #fff;
    color: #f36520;
  }
`;
